import { render, staticRenderFns } from "./YsPeephole‌.vue?vue&type=template&id=3ed756e4&scoped=true"
import script from "./YsPeephole‌.vue?vue&type=script&lang=js"
export * from "./YsPeephole‌.vue?vue&type=script&lang=js"
import style0 from "./YsPeephole‌.vue?vue&type=style&index=0&id=3ed756e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed756e4",
  null
  
)

export default component.exports